import type { TextField } from 'payload'

/** `#rgb`, `#rrggbb` ou `#rrggbbaa` (maiúsculas ou minúsculas). */
export const HEX_RE = /^#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i

export function isHexColor(value: unknown): value is string {
  return typeof value === 'string' && HEX_RE.test(value.trim())
}

/** Normaliza `#abc` → `#aabbcc`, minúsculas; `null` quando inválido. */
export function normalizeHex(value: unknown): string | null {
  if (!isHexColor(value)) return null
  const v = value.trim().toLowerCase()
  if (v.length === 4) {
    return `#${v[1]}${v[1]}${v[2]}${v[2]}${v[3]}${v[3]}`
  }
  return v
}

type CorHexArgs = {
  name: string
  label: string
  defaultValue?: string
  description?: string
  required?: boolean
  width?: string
  condition?: TextField['admin'] extends infer A
    ? A extends { condition?: infer C }
      ? C
      : never
    : never
}

/**
 * Campo de cor em hexadecimal com pré-visualização (componente `CorHexField`).
 * Valida `#hex`; vazio é aceite quando não obrigatório (o site usa o padrão do tema).
 */
export function corHex({
  name,
  label,
  defaultValue,
  description,
  required = false,
  width,
  condition,
}: CorHexArgs): TextField {
  return {
    name,
    type: 'text',
    label,
    ...(defaultValue ? { defaultValue } : {}),
    validate: (value: unknown) => {
      const v = typeof value === 'string' ? value.trim() : ''
      if (!v) return required ? 'Informe uma cor em hexadecimal (ex.: #1718fe).' : true
      return isHexColor(v) ? true : 'Cor inválida. Use o formato #rrggbb (ex.: #1718fe).'
    },
    admin: {
      ...(description ? { description } : {}),
      ...(width ? { width } : {}),
      ...(condition ? { condition } : {}),
      placeholder: '#1718fe',
      components: {
        Field: '@/components/payload/admin/CorHexField.client#CorHexField',
      },
    },
  }
}
